import { config } from "@/config";
import { chatApiAxios } from "@/plugins";
import { HttpRequestMethodEnum } from "@/types/api";
import { ISendMessage } from "@/types/chat";
import { getCommonJsonHeaders } from "@/utils/api";

export const sendMessageBeAsync = async ({
  chatId,
  messageText,
  messageId,
  attachments,
  messageType,
  replyToMessageId,
  modifyingMessageId,
  accessToken,
}: ISendMessage) => {
  const res = await chatApiAxios(config.api.chatApi.endpoints.message.index, {
    method: HttpRequestMethodEnum.POST,
    headers: getCommonJsonHeaders(accessToken),
    data: {
      chatId,
      messageId,
      messageText,
      attachments,
      messageType,
      replyToMessageId,
      modifyingMessageId,
    },
  });

  return res.data;
};
